import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DiscountsService, {
  API_ROUTES,
  IPostPromoCodeUploadData,
} from '@/common/integrations/menhir/employee/discounts/discounts.service';
import { useGetFeatures } from '@/common/integrations/menhir/employee/features/features.hooks';
import { IBenefitType } from '@/common/types/general';
import { useMutation, useQuery } from '@tanstack/react-query';

export function usePostPromoCode() {
  return useMutation({
    mutationFn: async ({ discount_id }: IPostPromoCodeUploadData) => {
      return await DiscountsService.postPromoCode(discount_id);
    },
  });
}

export function useGetDiscounts(category?: 'meals' | IBenefitType) {
  const {
    features: { FF_DISCOUNTS },
  } = useGetFeatures();
  const { i18n } = useTranslation();
  const { data } = useQuery({
    queryKey: [API_ROUTES.DISCOUNTS],
    queryFn: () => {
      return DiscountsService.getDiscounts();
    },
    enabled: FF_DISCOUNTS,
  });

  const { discounts, mealsDiscounts } = useMemo(() => {
    const discounts =
      data?.filter(
        (discount) =>
          i18n.exists(`wallet.discounts.${discount.partnerName}.name`) &&
          (category ? discount.category === category : true)
      ) ?? [];

    const mealsDiscounts =
      discounts?.filter((discount) => discount.category === 'meals') ?? [];

    return {
      discounts,
      mealsDiscounts,
    };
  }, [i18n, data, category]);

  return {
    discounts,
    mealsDiscounts,
  };
}
